import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { DASHBOARD } from "@/constants/testIds";

export const ImpactAllocation = ({ allocation }) => {
    if (!allocation) return null;
    const data = allocation.breakdown_pct;

    return (
        <section
            data-testid={DASHBOARD.allocation}
            className="rounded-lg border border-[#1f1f22] bg-[#080808] p-6 sm:p-8 lg:p-10"
        >
            <div className="mb-6">
                <span className="eviq-chip">Where every dollar goes</span>
                <h2 className="mt-4 font-editorial text-2xl leading-tight text-white sm:text-3xl md:text-4xl">
                    Impact, built into the price.
                </h2>
                <p className="mt-2 max-w-xl text-sm text-zinc-500">
                    Environmental and veteran contributions are treated as a cost of belonging —
                    not a donation add-on. You never see a "give more" prompt.
                </p>
            </div>

            <div className="grid grid-cols-1 gap-8 lg:grid-cols-[280px_1fr] lg:items-center">
                <div className="h-[240px]">
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={data}
                                dataKey="value"
                                cx="50%"
                                cy="50%"
                                innerRadius={60}
                                outerRadius={100}
                                paddingAngle={2}
                                stroke="#050505"
                            >
                                {data.map((entry, i) => (
                                    <Cell key={i} fill={entry.color} />
                                ))}
                            </Pie>
                            <Tooltip
                                contentStyle={{
                                    background: "#0a0a0a",
                                    border: "1px solid #27272a",
                                    borderRadius: 8,
                                    color: "#fff",
                                    fontFamily: "JetBrains Mono",
                                    fontSize: 12,
                                }}
                                formatter={(v) => [`${v}%`, ""]}
                            />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                    {data.map((row) => (
                        <div
                            key={row.name}
                            className="flex items-center justify-between gap-3 rounded-md border border-[#1f1f22] bg-[#0a0a0a] px-4 py-3"
                        >
                            <div className="flex min-w-0 items-center gap-3">
                                <span
                                    className="h-2.5 w-2.5 flex-shrink-0 rounded-full"
                                    style={{ background: row.color }}
                                />
                                <span className="truncate text-sm text-zinc-200">{row.name}</span>
                            </div>
                            <span className="flex-shrink-0 font-mono-metric text-sm font-bold text-white">
                                {row.value}%
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ImpactAllocation;
